import { useInfiniteQuery } from "@tanstack/react-query";
import { ApiGetCustodyStaticClaimLines } from "@/api";
import type {
  GetCustodyStaticClaimLinesResponse,
  GetCustodyStaticClaimLinesRequest,
} from "@/api/types";
import { getToken } from "@/lib/auth";

const PAGE_SIZE = 100;

export function useGetCustodyStaticClaimLines(sourceMergedOrderId?: string) {
  return useInfiniteQuery({
    queryKey: ["custodyStaticClaimLines", sourceMergedOrderId ?? ""],
    queryFn: async ({
      pageParam,
    }): Promise<GetCustodyStaticClaimLinesResponse> => {
      const req: GetCustodyStaticClaimLinesRequest = {
        page: pageParam,
        pageSize: PAGE_SIZE,
      };
      if (sourceMergedOrderId) req.sourceMergedOrderId = sourceMergedOrderId;
      const res = await ApiGetCustodyStaticClaimLines(req);
      console.log("ApiGetCustodyStaticClaimLines", res);
      return res.data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const lastSize = lastPage.lines?.length ?? 0;
      if (lastSize < PAGE_SIZE) return undefined;
      return allPages.length + 1;
    },
    enabled: !!getToken(),
  });
}
